import { MasterHelper } from '../../utilities';
import { AdditionalFilter } from '../rulebook/additional-filter';

export class SelfAssessmentT3Filter extends AdditionalFilter {
  fromDate: string = '';
  toDate: string = '';
  ruleBook: string[];
  searchQuery: string[];
  part: string[];
  owner: string[];
  regulatoryRuleFullRequirement: string[];
  assessmentTeam: string[];
  assessmentDetails: string[];
  assessmentStatus: string[];
  complianceStatus: string[];
  reviewDate: string = '';
  assessmentDate: string = '';
  lbgImpact: boolean | null = null;
  lbcmImpact: boolean | null = null;
  rfbImpact: boolean | null = null;
  nextassessmentDue: string = '';
  sortKey: string | null;
  isDesc: boolean = false;
  ruleId: string[];
  rulebookRuleId: string[];
  assessor: string[];

  constructor() {
    super();
    this.fromDate = '';
    this.toDate = MasterHelper.getDateStr(0);
    this.ruleBook = [];
    this.part = [];
    this.owner = [];
    this.regulatoryRuleFullRequirement = [];
    this.assessmentTeam = [];
    this.assessmentDetails = [];
    this.assessmentStatus = [];
    this.searchQuery = [];
    this.complianceStatus = [];
    this.sortKey = '';
    this.ruleId = [];
    this.rulebookRuleId =[];
    this.assessor= [];
  }
}
